import * as t from "io-ts";
export const createWebBookerT = t.strict({
    clientId: t.string,
    firstName: t.string,
    lastName: t.string,
    email: t.string,
});
export const webBookerT = t.intersection([
    createWebBookerT,
    t.strict({ id: t.string }),
]);
export const webBookersT = t.array(webBookerT);
//# sourceMappingURL=web-booking.js.map